import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryUsersParams, queryUsers } from "supabase/users";

export const useQueryUsers = (params: QueryUsersParams) => {
  const { name, page, perPage } = params;

  const { isLoading, isError, error, data } = useQuery({
    queryKey: ["users", { name, page }],
    queryFn: () => {
      return queryUsers({
        name,
        page,
        perPage,
      });
    },
    placeholderData: keepPreviousData,
  });

  return {
    isLoading,
    isError,
    error,
    count: data?.count,
    users: data?.users,
  };
};
